import { http } from "./api-config";
import store from "../store";

const apiAuthorizationClient = http(process.env.VUE_APP_AUTHORIZATION_SERVICE)
export default {
    async getUserAccessPermissions(id) {
        let headers = {};
        if (store.state.variables.cashAccessPermission) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashAccessPermission', true)
        const res = await apiAuthorizationClient.get(`userpermissions/${id}`, { headers })
        return res.data
    },
    async getLoggedInUserDetails() {
        let headers = {};
        if (store.state.variables.cashUser) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashUser', true)
        const res = await apiAuthorizationClient.get('user', { headers })
        return res.data
    },
    async setActivityLog(activity) {
        await apiAuthorizationClient.post(`activitylogs/${activity}`)
    }
}